import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.scss';
import MenuBar from './components/menuBar.vue';
import HeaderMenu from './components/HeaderMenu.vue';
import { VsxIcon } from "vue-iconsax";
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/lara-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import Vuesax from 'vuesax3';
import 'vuesax3/dist/vuesax.css';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import './registerServiceWorker'
import i18n from './locales'


const app = createApp(App);

app.use(router);
app.use(PrimeVue, {
    ripple: true
});
app.use(Toast);
app.use(store);
app.use(VueSweetalert2);
app.use(i18n);
app.use(PerfectScrollbarPlugin, {
    componentName: 'Scrollbar'
});
app.use(Vuesax, {});

app.component("VsxIcon", VsxIcon);
app.component('menu-bar', MenuBar);
app.component('header-menu', HeaderMenu);

app.mount('#app');